export enum NotificationType {
  Success,
  Error
}

export interface NotificationProps {
  message: string;
  type: NotificationType;
  isClosing: boolean;
  closeNotification: () => void;
}
